import { ref } from 'vue'

const isLoginLoaderLoading = ref(false)

function setLoginLoaderLoading(bool = false) {
  isLoginLoaderLoading.value = bool
}

export { isLoginLoaderLoading, setLoginLoaderLoading }
